// Voguta Child — entry point
import '../scss/main.scss';

/**
 * Sync radio buttons (size selector) → hidden select (WC).
 *
 * WooCommerce's variation form JS listens for `change` events on `.variations select`
 * to decide which product variation matches. Our variable.php replaces the
 * dropdown with radio buttons (nicer UX), but keeps a hidden select that WC
 * can read. This script syncs the two.
 */
(function () {
  function initSizeSelector() {
    // Use event delegation so it works on dynamically-added forms too.
    document.addEventListener('change', function (e) {
      const radio = e.target;
      if (!radio.matches('input[type="radio"][data-target-select]')) {
        return;
      }

      const targetName = radio.dataset.targetSelect;
      const form       = radio.closest('form.variations_form');
      if (!form) return;

      const select = form.querySelector('select[name="' + targetName + '"]');
      if (!select) return;

      select.value = radio.value;

      // Trigger the change event that WC's variation JS listens to.
      // WC still uses jQuery, so use jQuery if available (guarantees compatibility).
      if (window.jQuery) {
        window.jQuery(select).trigger('change');
      } else {
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // Also handle the "Limpar seleção" (reset) link that WC provides.
    document.addEventListener('click', function (e) {
      if (!e.target.matches('.reset_variations')) return;
      const form = e.target.closest('form.variations_form');
      if (!form) return;
      // Uncheck all our visible radios; WC's own JS resets the selects.
      form.querySelectorAll('input[type="radio"][data-target-select]').forEach(function (r) {
        r.checked = false;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeSelector);
  } else {
    initSizeSelector();
  }
})();

// Adiciona classe `.is-scrolled` na nav sticky quando o usuário rola.
(function () {
  const nav = document.getElementById('vg-site-nav');
  if (!nav) return;

  const onScroll = function () {
    const rect = nav.getBoundingClientRect();
    if (rect.top <= 0) {
      nav.classList.add('is-scrolled');
    } else {
      nav.classList.remove('is-scrolled');
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// Slideshow simples do hero da escola — auto-rotaciona `.is-active`
// entre as slides a cada 5s. Sem lib, sem dependência.
(function () {
  function initSchoolHeroSlides() {
    const containers = document.querySelectorAll('.vg-school-hero--slideshow .vg-school-hero__slides');
    containers.forEach(function (slidesEl) {
      const slides = slidesEl.querySelectorAll('.vg-school-hero__slide');
      if (slides.length <= 1) return;
      let current = 0;
      setInterval(function () {
        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
      }, 5000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSchoolHeroSlides);
  } else {
    initSchoolHeroSlides();
  }
})();

// Galeria custom da página de produto — substitui o flexslider do WC.
// Rendemos:
//   - Mostra só a imagem ativa (as demais ficam escondidas)
//   - Gera thumbnail nav a partir dos data-thumb dos images
//   - Click num thumb: swap in-place da imagem ativa
//   - Click na imagem principal: nada (sem lightbox, sem navegação)
(function () {
  function initProductGallery() {
    const galleries = document.querySelectorAll('.woocommerce-product-gallery');
    galleries.forEach(function (gallery) {
      const images = gallery.querySelectorAll('.woocommerce-product-gallery__wrapper > .woocommerce-product-gallery__image');
      if (!images.length) return;

      // Marca gallery com class pra CSS lidar com estado ativo
      gallery.classList.add('vg-gallery--ready');

      // Ativa primeira, esconde as outras
      images.forEach(function (img, i) {
        if (i === 0) img.classList.add('vg-is-active');
        img.classList.remove('vg-was-active');
      });

      // Previne navegação nativa nos anchors das imagens principais
      gallery.addEventListener('click', function (e) {
        const link = e.target.closest('.woocommerce-product-gallery__image a');
        if (link) e.preventDefault();
      });

      // Só gera thumbs se tiver 2+ imagens
      if (images.length <= 1) return;

      // Se WC/flexslider já criou uma .flex-control-thumbs, usa ela.
      // Caso contrário, cria a nossa.
      let thumbsList = gallery.querySelector('.flex-control-thumbs');
      if (!thumbsList) {
        thumbsList = document.createElement('ol');
        thumbsList.className = 'flex-control-nav flex-control-thumbs';
        images.forEach(function (imgDiv) {
          const thumbUrl = imgDiv.getAttribute('data-thumb')
            || (imgDiv.querySelector('img') && imgDiv.querySelector('img').src);
          const alt = imgDiv.getAttribute('data-thumb-alt')
            || (imgDiv.querySelector('img') && imgDiv.querySelector('img').alt)
            || '';
          const li  = document.createElement('li');
          const img = document.createElement('img');
          img.src = thumbUrl;
          img.alt = alt;
          li.appendChild(img);
          thumbsList.appendChild(li);
        });
        gallery.appendChild(thumbsList);
      }

      const thumbs = thumbsList.querySelectorAll('li');
      // Marca primeiro thumb como ativo
      thumbs.forEach(function (t, i) {
        const timg = t.querySelector('img');
        if (timg) {
          if (i === 0) timg.classList.add('flex-active');
          else timg.classList.remove('flex-active');
        }
      });

      // Click handler
      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function (e) {
          e.preventDefault();
          // Swap imagem ativa
          images.forEach(function (img) { img.classList.remove('vg-is-active'); });
          if (images[index]) images[index].classList.add('vg-is-active');
          // Swap thumb ativo
          thumbs.forEach(function (t) {
            const ti = t.querySelector('img');
            if (ti) ti.classList.remove('flex-active');
          });
          const activeImg = thumb.querySelector('img');
          if (activeImg) activeImg.classList.add('flex-active');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGallery);
  } else {
    initProductGallery();
  }
})();

console.log('[voguta-child] front-end carregado');
